import { AbnInput } from "./AbnInput";
import { AddressInput } from "./AddressInput";
import { AnzsicCodeInput } from "./AnzsicCodeInput";
import { BooleanInput } from "./BooleanInput";
import { CardSelect } from "./CardSelect";
import { CheckboxInput } from "./CheckboxInput";
import { DateInput } from "./DateInput";
import { EmailInput } from "./EmailInput";
import { ExpirationInput } from "./ExpirationInput";
import { FileUploadInput } from "./FileUploadInput";
import { FloatInput } from "./FloatInput";
import { FormInput } from "./FormInput";
import { FormListInput } from "./FormListInput";
import { InputRegistry } from "kanopi-components/InputRegistry";
import { IntegerInput } from "./IntegerInput";
import { ListDisplayInput } from "./ListDisplayInput";
import { PaymentFrequencyInput } from "./PaymentFrequencyInput";
import { PhoneInput } from "./PhoneInput";
import { RadioInput } from "./RadioInput";
import { RevenueInput } from "./RevenueInput";
import { Select } from "./Select";
import { StringInput } from "./StringInput";
import { TextareaInput } from "./TextareaInput";
import { TimeInput } from "./TimeInput";

export const inputRegistry = new InputRegistry({
  string: StringInput,
  boolean: BooleanInput,
  checkbox: CheckboxInput,
  "radio-button": RadioInput,
  email: EmailInput,
  date: DateInput,
  time: TimeInput,
  integer: IntegerInput,
  "positive-integer": IntegerInput,
  "positive-float": FloatInput,
  float: FloatInput,
  "anzsic-code": AnzsicCodeInput,
  abn: AbnInput,
  address: AddressInput,
  revenue: RevenueInput,
  currency: RevenueInput, // TODO: Should probably be currency?
  select: Select,
  "card-select": CardSelect,
  form: FormInput,
  "form-list": FormListInput,
  "list-display": ListDisplayInput,
  "file-upload": FileUploadInput,
  phone: PhoneInput,
  expiry: ExpirationInput,
  "payment-frequency": PaymentFrequencyInput,
  textarea: TextareaInput,
});
